/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


// CUSTOM BL DEV
window.addEventListener('DOMContentLoaded', function () {
  function isVideoIframe(iframe) {
    if (!iframe || !iframe.src) {
      return false;
    }

    return iframe.src.indexOf('youtube') !== -1 || iframe.src.indexOf('youtu.be') !== -1 || iframe.src.indexOf('vimeo') !== -1;
  }

  function pauseIframe(iframe) {
    if (!iframe || !iframe.contentWindow) {
      return;
    }

    try {
      if (iframe.src.indexOf('youtube') !== -1 || iframe.src.indexOf('youtu.be') !== -1) {
        iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: '' }), '*');
      } else if (iframe.src.indexOf('vimeo') !== -1) {
        iframe.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), '*');
      } else {
        iframe.src = iframe.src;
      }
    } catch (error) {
      iframe.src = iframe.src;
    }
  }

  function pauseMediaInScope(scope) {
    if (!scope) {
      return;
    }

    scope.querySelectorAll('native-video, external-video').forEach(function (element) {
      if (typeof element.pause === 'function') {
        element.pause();
      }
    });

    scope.querySelectorAll('video').forEach(function (video) {
      try {
        video.pause();
        video.currentTime = 0;
      } catch (error) {
      }
    });

    scope.querySelectorAll('iframe').forEach(function (iframe) {
      pauseIframe(iframe);
    });
  }

  function getEmbedVideoUrl(rawValue) {
    if (!rawValue) {
      return '';
    }

    var externalValue = rawValue.trim();

    if (externalValue.indexOf('<iframe') !== -1) {
      var iframeParser = document.createElement('div');
      iframeParser.innerHTML = externalValue;
      var iframeFromMarkup = iframeParser.querySelector('iframe');

      if (iframeFromMarkup && iframeFromMarkup.src) {
        externalValue = iframeFromMarkup.src;
      }
    }

    try {
      var parsedUrl = new URL(externalValue);
      var host = parsedUrl.hostname.replace('www.', '');

      if (host === 'youtu.be' || host === 'youtube.com' || host === 'm.youtube.com') {
        var youtubeId = '';

        if (host === 'youtu.be') {
          youtubeId = parsedUrl.pathname.replace('/', '').split('/')[0];
        } else if (parsedUrl.pathname === '/watch') {
          youtubeId = parsedUrl.searchParams.get('v') || '';
        } else if (parsedUrl.pathname.indexOf('/shorts/') === 0) {
          youtubeId = parsedUrl.pathname.split('/')[2] || '';
        } else if (parsedUrl.pathname.indexOf('/embed/') === 0) {
          youtubeId = parsedUrl.pathname.split('/')[2] || '';
        }

        if (!youtubeId) {
          return externalValue;
        }

        return 'https://www.youtube.com/embed/' + youtubeId + '?enablejsapi=1&rel=0';
      }

      if (host === 'vimeo.com' || host === 'player.vimeo.com') {
        var segments = parsedUrl.pathname.split('/').filter(Boolean);
        var vimeoId = segments[segments.length - 1] || '';

        if (!vimeoId) {
          return externalValue;
        }

        return 'https://player.vimeo.com/video/' + vimeoId;
      }

      return externalValue;
    } catch (error) {
      return externalValue;
    }
  }

  function createExternalVideoIframe(rawValue) {
    var embedUrl = getEmbedVideoUrl(rawValue);

    if (!embedUrl) {
      return null;
    }

    var iframe = document.createElement('iframe');

    iframe.classList.add('content-modal__media-video');
    iframe.setAttribute('loading', 'lazy');
    iframe.setAttribute('allowfullscreen', 'allowfullscreen');
    iframe.setAttribute('allow', 'autoplay; encrypted-media; fullscreen; picture-in-picture');
    iframe.src = embedUrl;

    return iframe;
  }

  function normalizeMediaNode(node) {
    var mediaNode = node.cloneNode(true);

    if (mediaNode.tagName === 'IMG') {
      mediaNode.classList.add('content-modal__media-image');
      mediaNode.setAttribute('loading', 'lazy');
      mediaNode.setAttribute('decoding', 'async');
    }

    if (mediaNode.tagName === 'VIDEO') {
      mediaNode.classList.add('content-modal__media-video');
      mediaNode.setAttribute('controls', 'controls');
      mediaNode.setAttribute('playsinline', 'playsinline');
      mediaNode.removeAttribute('autoplay');
    }

    if (mediaNode.tagName === 'IFRAME') {
      mediaNode.classList.add('content-modal__media-video');
      mediaNode.setAttribute('loading', 'lazy');
      mediaNode.setAttribute('allowfullscreen', 'allowfullscreen');
    }

    return mediaNode;
  }

  function getMetafieldModalMediaNodes(article) {
    var mediaRoot = article.querySelector('.article-item__modal-metafields');

    if (!mediaRoot) {
      return [];
    }

    var mediaNodes = [];
    var videoFileNode = mediaRoot.querySelector('.article-item__modal-video-file video, .article-item__modal-video-file iframe, .article-item__modal-video-file native-video, .article-item__modal-video-file external-video');
    var externalVideoValue = (mediaRoot.getAttribute('data-modal-video-external') || '').trim();

    if (externalVideoValue) {
      var externalVideoNode = createExternalVideoIframe(externalVideoValue);

      if (externalVideoNode) {
        mediaNodes.push(externalVideoNode);
      }
    } else if (videoFileNode) {
      mediaNodes.push(normalizeMediaNode(videoFileNode));
    }

    mediaRoot.querySelectorAll('.article-item__modal-image-list img').forEach(function (imageNode) {
      mediaNodes.push(normalizeMediaNode(imageNode));
    });

    return mediaNodes;
  }

  function renderModalMedia(modal, mediaNodes) {
    var mediaContainer = modal.querySelector('.content-modal__media');
    var mediaTemplate = modal.querySelector('.content-modal__media-template');

    if (!mediaContainer || !mediaTemplate) {
      return;
    }

    mediaContainer.innerHTML = '';

    if (!mediaNodes || mediaNodes.length === 0) {
      mediaContainer.hidden = true;
      return;
    }

    var mediaFragment = mediaTemplate.content.cloneNode(true);
    var mediaPages = mediaFragment.querySelector('.content-modal__media-pages');
    var mediaScrollerInner = mediaFragment.querySelector('.content-modal__media-scroller-inner');
    var mediaControls = mediaFragment.querySelector('.content-modal__media-prev-next');
    var uniqueId = Date.now().toString();

    mediaNodes.forEach(function (mediaNode, index) {
      var nodeClone = mediaNode.cloneNode(true);

      var item = document.createElement('native-carousel-item');
      var frame = document.createElement('div');

      item.id = 'content-modal-media-' + uniqueId + '-' + index;
      item.className = 'content-modal__media-item';

      if (index > 0) {
        item.setAttribute('hidden', 'hidden');
      }

      frame.className = 'content-modal__media-frame';
      frame.appendChild(mediaNode);

      item.appendChild(frame);

      if (mediaPages) {
        mediaPages.appendChild(item);
      }

      if (mediaScrollerInner) {
        var scrollerItem = document.createElement('div');
        scrollerItem.className = 'content-modal__media-item';

        var scrollerFrame = document.createElement('div');
        scrollerFrame.className = 'content-modal__media-frame';
        scrollerFrame.appendChild(nodeClone);

        scrollerItem.appendChild(scrollerFrame);
        mediaScrollerInner.appendChild(scrollerItem);
      }
    });

    if (mediaControls) {
      var hasVideo = mediaNodes.some(function (node) {
        var tagName = node.tagName.toUpperCase();
        return tagName === 'VIDEO' || tagName === 'IFRAME' || tagName === 'NATIVE-VIDEO' || tagName === 'EXTERNAL-VIDEO' || node.classList.contains('content-modal__media-video');
      });

      var shouldHide = mediaNodes.length <= 1 || hasVideo;

      mediaControls.hidden = shouldHide;

      if (shouldHide) {
        mediaControls.style.setProperty('display', 'none', 'important');
      } else {
        mediaControls.style.removeProperty('display');
      }
    }

    mediaContainer.appendChild(mediaFragment);
    mediaContainer.hidden = false;
  }

  function initializeLegacyBlogPostModal(section) {
    if (!section || section.dataset.blogModalLegacyInitialized === 'true') {
      return;
    }

    var modal = section.querySelector('modal-content');

    if (!modal) {
      return;
    }

    section.dataset.blogModalLegacyInitialized = 'true';

    section.querySelectorAll('.article-item').forEach(function (article) {
      if (article.classList.contains('nomodal')) {
        return;
      }

      var title = article.querySelector('.article-item__title');
      var content = article.querySelector('.article-item-content');

      if (!content || !content.innerHTML) {
        return;
      }

      article.addEventListener('click', function (event) {
        var modalTitle = modal.querySelector('.content-modal__content-title');
        var modalContent = modal.querySelector('.content-modal__content-text');

        if (!modalTitle || !modalContent) {
          return;
        }

        event.preventDefault();

        modalTitle.innerHTML = title ? title.innerText : '';
        modalContent.innerHTML = content.innerHTML;

        modal.open = true;
      });
    });
  }

  function initializeCarouselBlogPostModal(section) {
    if (!section || section.dataset.blogModalInitialized === 'true') {
      return;
    }

    var modal = section.querySelector('modal-content');

    if (!modal) {
      return;
    }

    section.dataset.blogModalInitialized = 'true';

    section.addEventListener('click', function (event) {
      var article = event.target.closest('.article-item');

      if (!article || !section.contains(article) || article.classList.contains('nomodal')) {
        return;
      }

      var content = article.querySelector('.article-item-content');
      var title = article.querySelector('.article-item__title');
      var modalTitle = modal.querySelector('.content-modal__content-title');
      var modalContent = modal.querySelector('.content-modal__content-text');

      if (!content || !modalTitle || !modalContent) {
        return;
      }

      event.preventDefault();

      pauseMediaInScope(modal);
      var mediaNodes = getMetafieldModalMediaNodes(article);

      modalTitle.textContent = title ? title.innerText.trim() : '';
      modalContent.innerHTML = content.innerHTML;
      renderModalMedia(modal, mediaNodes);

      modal.open = true;
    });

    modal.addEventListener('openable-element:close', function (event) {
      if (event.target !== modal) {
        return;
      }

      pauseMediaInScope(modal);
    });

    modal.addEventListener('prev-next:prev', function (event) {
      if (!event.target.closest('.content-modal__media')) {
        return;
      }

      setTimeout(function () {
        modal.querySelectorAll('.content-modal__media native-carousel-item[hidden]').forEach(function (item) {
          pauseMediaInScope(item);
        });
      }, 0);
    });

    modal.addEventListener('prev-next:next', function (event) {
      if (!event.target.closest('.content-modal__media')) {
        return;
      }

      setTimeout(function () {
        modal.querySelectorAll('.content-modal__media native-carousel-item[hidden]').forEach(function (item) {
          pauseMediaInScope(item);
        });
      }, 0);
    });
  }

  document.querySelectorAll('.shopify-section--blog-posts-carousel').forEach(function (section) {
    initializeCarouselBlogPostModal(section);
  });

  document.querySelectorAll('.shopify-section--blog-posts:not(.shopify-section--blog-posts-carousel)').forEach(function (section) {
    initializeLegacyBlogPostModal(section);
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || !event.target.classList) {
      return;
    }

    if (event.target.classList.contains('shopify-section--blog-posts-carousel')) {
      initializeCarouselBlogPostModal(event.target);
      return;
    }

    if (event.target.classList.contains('shopify-section--blog-posts')) {
      initializeLegacyBlogPostModal(event.target);
    }
  });
});
